import React, { useRef, useState } from 'react';
import { View, Text, ScrollView, TouchableOpacity, Image } from 'react-native-web';
import * as Animatable from 'react-native-animatable';
import Feather from 'react-native-vector-icons/dist/Feather';
import { useRoute } from '@react-navigation/native';

// Components
import CollapsibleView from '../../components/component_collapsible_view';

// Utils
import { toTitleCase } from '../../utils/util_helpers';

// Configs
import GLOBAL from '../../configs/config_global';
import DATA from '../../configs/config_data';

export function More() {
    const DELAY_VALUE = 150;

    const { scrollToSMS } = useRoute()?.params || {};

    // region Refs
    const mainView = useRef(null);
    const privacyPolicyScrollView = useRef(null);
    // endregion

    // region Local State
    const [selectedItemID, setSelectedItemID] = useState(1);
    const [smsViewPosY, setSmsViewPosY] = useState(0);
    // endregion

    // region Render About Us Section
    const renderAboutUsSection = () => (
        <View style={{ flex: 1, width: '100%' }}>
            <ScrollView style={{ flex: 1 }} contentContainerStyle={{ padding: 48 }}>
                {/* Truckster Image */}
                <Image
                    animation={'fadeIn'}
                    source={require('../../images/image_truckster_text.png')}
                    style={{ height: 48, width: 190 / 30 * 48, marginBottom: 48, alignSelf: 'center' }}
                    resizeMode={'stretch'}
                />

                {/* Intro */}
                <Text style={{ fontSize: 18, lineHeight: 30, color: 'black' }}>
                    After running a food truck for four years in Denver, it became apparent to Connor that food trucks and consumers need a better way to connect. Few consumers are willing to follow multiple food trucks to find their locations, while food trucks are continuously on the move, creating a difficult environment for the love affair to work. Throw breweries into the mix and it becomes increasingly hard to plan a day that includes one of your favorite breweries and trucks.
                    {'\n\n'}
                    Connor and his wife Molly teamed up to build Truckster, your hub for everything food trucks. We love the food truck movement and how it is constantly evolving, delivering creative, delicious food that is accessible to everyone, all through a unique experience. Our goal is to be a tool that helps grow the food truck industry and the culinary joy it brings. Whether you are traveling to a new city, in an unfamiliar part of your home city, or are just a foodie on the go, Truckster will elevate your food truck experience.
                </Text>

                <Text style={{ fontSize: 18, fontWeight: 'bold', lineHeight: 30, color: 'black' }}>
                    {'\n\n'}Truckster enables consumers to:
                </Text>

                <Text style={{ color: GLOBAL.COLOR.TEXT_GRAY, fontWeight: 'normal', fontSize: 18, lineHeight: 36, marginTop: 8 }}>
                    ✓ Explore the best food trucks and breweries
                    {'\n'}✓ Use a map to find nearby food trucks
                    {'\n'}✓ View ratings and reviews
                    {'\n'}✓ Skip the lines with mobile ordering
                    {'\n'}✓ Share events, trucks, and breweries with friends
                    {'\n'}✓ Follow your favorite food trucks and breweries all on one platform
                </Text>

                <Text style={{ fontWeight: 'bold', color: 'black' }}>
                    {'\n\n'}For food trucks and breweries, Truckster delivers:
                </Text>

                <Text style={{ color: GLOBAL.COLOR.TEXT_GRAY, fontWeight: 'normal', fontSize: 18, lineHeight: 36, marginTop: 8 }}>
                    ✓ Increased sales opportunities through mobile ordering
                    {'\n'}✓ Integration into popular POS systems, easing the process workflow
                    {'\n'}✓ Enhanced consumer relationship
                    {'\n'}✓ Outsourced marketing service
                    {'\n'}✓ Dashboards and analytics
                </Text>

                <Text style={{ color: 'black', fontSize: 18, lineHeight: 30 }}>
                    {'\n\n'}Truckster is new, fun, and the best way to eat through your city. What are you waiting for? It’s time to jump on board! #Truckyeah!
                </Text>
            </ScrollView>
        </View>
    )
    // endregion

    // region Render FAQ Section
    const renderFAQSection = () => (
        <View style={{ flex: 1, width: '100%' }}>
            <ScrollView style={{ flex: 1 }} contentContainerStyle={{ padding: 48, paddingTop: 24 }}>
                {
                    DATA.helpCenter.map((item, index) => (
                        <CollapsibleView
                            key={`helpItem_${index}`}
                            showDivider={index < DATA.helpCenter.length - 1}
                            expandInitially={false}
                            title={item.question}>
                            <Text style={{ alignSelf: 'stretch', color: GLOBAL.COLOR.BASIC.WARM_GREY, fontSize: 18, lineHeight: 32, marginVertical: 8 }}>
                                {item.answer}
                            </Text>
                        </CollapsibleView>
                    ))
                }
            </ScrollView>
        </View>
    );
    // endregion

    // region Render Privacy Policy Section
    const renderPrivacyPolicySection = () => (
        <ScrollView
            ref={privacyPolicyScrollView}
            style={{ flex: 1, width: '100%' }} contentContainerStyle={{ padding: 48 }}>
            <Text style={{ fontSize: 18, lineHeight: 30, color: 'black' }}>
                <Text style={{ fontWeight: '900', fontSize: 24 }}>
                    Owner and Data Controller
                </Text>
                {'\n\n'}Truckster
                {'\n'}Xavier St, Denver, CO 80212
                {'\n'}Owner contact email:
                <Text style={{ color: GLOBAL.COLOR.MAIN, fontSize: 18 }}>
                    {' '}connor@gotruckster.com{'\n'}
                </Text>
            </Text>

            <View style={{ alignSelf: 'stretch', height: 1, backgroundColor: 'rgba(0, 0, 0, 0.1)', marginVertical: 15 }}/>

            <Text style={{ fontSize: 18, lineHeight: 32, color: 'black' }}>
                <Text style={{ fontWeight: '900', fontSize: 24 }}>
                    Types of Data Collected
                </Text>
                {'\n\n'}Among the types of Personal Data that this Application collects, by itself or through third parties, there are: Calendar permission, Approximate location permission (non-continuous), SMS permission, Reminders permission, food related activity and date of birth.
                {'\n\n'}Complete details on each type of Personal Data collected are provided in the dedicated sections of this privacy policy or by specific explanation texts displayed prior to the Data collection.
                The Personal Data may be freely provided by the User, or, in case of Usage Data, collected automatically when using this Application.
                All Data requested by this Application is mandatory and failure to provide this Data may make it impossible for this Application to provide its services. In cases where this Application specifically states that some Data is not mandatory, Users are free not to communicate this Data without any consequences on the availability or the functioning of the service.
                Users who are uncertain about which Personal Data is mandatory are welcome to contact the Owner.
                Any use of Cookies – or of other tracking tools – by this Application or by the owners of third-party services used by this Application serves the purpose of providing the service required by the User, in addition to any other purposes described in the present document and in the Cookie Policy, if available.
                {'\n\n'}Users are responsible for any third-party Personal Data obtained, published or shared through this Application and confirm that they have the third party's consent to provide the Data to the Owner.
            </Text>

            <View style={{ alignSelf: 'stretch', height: 1, backgroundColor: 'rgba(0, 0, 0, 0.1)', marginVertical: 15 }}/>

            <Text style={{ fontSize: 18, lineHeight: 32, color: 'black' }}>
                <Text style={{ fontWeight: '900', fontSize: 24 }}>
                    Mode and place of processing the Data
                </Text>
                <Text style={{ fontSize: 18, fontWeight: '900' }}>
                    {'\n\n'}Methods of processing
                </Text>
                {'\n\n'}The Data Controller processes the Data of Users in a proper manner and shall take appropriate security measures to prevent unauthorized access, disclosure, modification, or unauthorized destruction of the Data.
                {'\n\n'}The Data processing is carried out using computers and/or IT enabled tools, following organizational procedures and modes strictly related to the purposes indicated. In addition to the Data Controller, in some cases, the Data may be accessible to certain types of persons in charge, involved with the operation of the site (administration, sales, marketing, legal, system administration) or external parties (such as third-party technical service providers, mail carriers, hosting providers, IT companies, communications agencies) appointed, if necessary, as Data Processors by the Owner. The updated list of these parties may be requested from the Data Controller at any time.

                <Text style={{ fontSize: 18, fontWeight: '900' }}>
                    {'\n\n'}Place
                </Text>
                {'\n\n'}The Data is processed at the Data Controller's operating offices and in any other places where the parties involved with the processing are located. For further information, please contact the Data Controller.

                <Text style={{ fontSize: 18, fontWeight: '900' }}>
                    {'\n\n'}Retention time
                </Text>
                {'\n\n'}The Data is kept for the time necessary to provide the service requested by the User, or stated by the purposes outlined in this document, and the User can always request that the Data Controller suspend or remove the data.
            </Text>

            <View style={{ alignSelf: 'stretch', height: 1, backgroundColor: 'rgba(0, 0, 0, 0.1)', marginVertical: 15 }}/>

            <Text style={{ fontSize: 18, lineHeight: 30, color: 'black' }}>
                <Text style={{ fontWeight: '900', fontSize: 24 }}>
                    The use of the collected Data
                </Text>

                {'\n\n'}The Data concerning the User is collected to allow the Owner to provide its services, as well as for the following purposes: Access to third-party accounts, Device permissions for Personal Data access and Handling activity data.
                {'\n\n'}The Personal Data used for each purpose is outlined in the specific sections of this document.
            </Text>

            <View style={{ alignSelf: 'stretch', height: 1, backgroundColor: 'rgba(0, 0, 0, 0.1)', marginVertical: 15 }}/>

            <Text style={{ fontSize: 18, lineHeight: 32, color: 'black' }}>
                <Text style={{ fontWeight: '900', fontSize: 22 }}>
                    Facebook permissions asked by this Application
                </Text>

                {'\n\n'}This Application may ask for some Facebook permissions allowing it to perform actions with the User's Facebook account and to retrieve information, including Personal Data, from it. This service allows this Application to connect with the User's account on the Facebook social network, provided by Facebook Inc.
                {'\n\n'}For more information about the following permissions, refer to the Facebook permissions documentation and to the Facebook privacy policy.
                {'\n\n'}The permissions asked are the following:

                <Text style={{ fontSize: 18, fontWeight: '900' }}>
                    {'\n\n'}Basic information
                </Text>
                {'\n\n'}By default, this includes certain User’s Data such as id, name, picture, gender, and their locale. Certain connections of the User, such as the Friends, are also available. If the User has made more of their Data public, more information will be available.

                <Text style={{ fontSize: 18, fontWeight: '900' }}>
                    {'\n\n'}App Notifications
                </Text>
                {'\n\n'}Send notifications.

                <Text style={{ fontSize: 18, fontWeight: '900' }}>
                    {'\n\n'}Birthday
                </Text>
                {'\n\n'}Provides access to the birthday.

                <Text style={{ fontSize: 18, fontWeight: '900' }}>
                    {'\n\n'}Contact email
                </Text>
                {'\n\n'}Access the User's contact email address.

                <Text style={{ fontSize: 18, fontWeight: '900' }}>
                    {'\n\n'}Current City
                </Text>
                {'\n\n'}Provides access to the User's current location.
            </Text>

            <View style={{ alignSelf: 'stretch', height: 1, backgroundColor: 'rgba(0, 0, 0, 0.1)', marginVertical: 15 }}/>

            <Text style={{ fontSize: 18, lineHeight: 32, color: 'black' }}>
                <Text style={{ fontWeight: '900', fontSize: 22 }}>
                    Device permissions for Personal Data access
                </Text>

                {'\n\n'}Depending on the User's specific device, this Application may request certain permissions that allow it to access the User's device Data as described below.
                {'\n\n'}By default, these permissions must be granted by the User before the respective information can be accessed. Once the permission has been given, it can be revoked by the User at any time. In order to revoke these permissions, Users may refer to the device settings or contact the Owner for support at the contact details provided in the present document.
                The exact procedure for controlling app permissions may be dependent on the User's device and software.
                {'\n\n'}Please note that the revoking of such permissions might impact the proper functioning of this Application.
                {'\n\n'}If User grants any of the permissions listed below, the respective Personal Data may be processed (i.e accessed to, modified or removed) by this Application.

                <Text style={{ fontSize: 18, fontWeight: '900' }}>
                    {'\n\n'}Approximate location permission (non-continuous)
                </Text>
                {'\n\n'}Used for accessing the User's approximate device location. This Application may collect, use, and share User location Data in order to provide location-based services.{'\n'}
                The geographic location of the User is determined in a manner that isn't continuous. This means that it is impossible for this Application to derive the approximate position of the User on a continuous basis.

                <Text style={{ fontSize: 18, fontWeight: '900' }}>
                    {'\n\n'}Calendar permission
                </Text>
                {'\n\n'}Used for accessing the calendar on the User's device, including the reading, adding and removing of entries.

                <Text style={{ fontSize: 18, fontWeight: '900' }}>
                    {'\n\n'}Reminders permission
                </Text>
                {'\n\n'}Used for accessing the Reminders app on the User's device, including the reading, adding and removing of entries.
            </Text>

            <View
                onLayout={(e) => {
                    const posY = e.nativeEvent.layout.y + 32;
                    !smsViewPosY && setSmsViewPosY(posY);
                    if (scrollToSMS) {
                        setTimeout(() => privacyPolicyScrollView.current?.scrollTo({ y: posY, animated: true }), 500);
                    }
                }}>
                <Text style={{ fontSize: 18, lineHeight: 32, color: 'black' }}>
                    <Text style={{ fontSize: 18, fontWeight: '900' }}>
                        {'\n'}SMS permission
                    </Text>
                    {'\n\n'}Used for accessing features related to the User's messaging including the sending, receiving and reading of SMS.

                    <Text style={{ fontSize: 18, fontWeight: '900' }}>
                        {'\n\n'}SMS Terms of Services
                    </Text>
                    {'\n\n'}Users may opt into SMS communication while submitting catering requests or creating Truckster Vendor accounts.
                    {'\n\n'}Truckster Catering SMS - users are sent reminders, updates, and confirmations regarding their catering request with Truckster or regarding a neighborhood or partner that is managed with Truckster. 2 messages per event and/or request maximum are sent. Message and data rates may apply. Reply HELP for help and STOP to cancel.
                    {'\n\n'}Truckster Vendor SMS - users are sent account notifications and event confirmations via SMS. Messaging frequency varies. Message and data rates may apply. Reply HELP for help and STOP to cancel.
                    {'\n\n'}Data obtained through the short code program will not be shared with any third-parties for their marketing reasons/purposes.
                    {'\n\n'}Carriers are not liable for delayed for undelivered messages.
                </Text>
            </View>

            <View style={{ alignSelf: 'stretch', height: 1, backgroundColor: 'rgba(0, 0, 0, 0.1)', marginVertical: 15 }}/>

            <Text style={{ fontSize: 18, lineHeight: 30, color: 'black' }}>
                <Text style={{ fontWeight: '900', fontSize: 24 }}>
                    Additional information about Data collection and processing
                </Text>

                <Text style={{ fontSize: 18, fontWeight: '900' }}>
                    {'\n\n'}Legal action
                </Text>
                {'\n\n'}The User's Personal Data may be used for legal purposes by the Data Controller, in Court or in the stages leading to possible legal action arising from improper use of this Application or the related services.
                The User declares to be aware that the Data Controller may be required to reveal personal data upon request of public authorities.

                <Text style={{ fontSize: 18, fontWeight: '900' }}>
                    {'\n\n'}Additional information about User's Personal Data
                </Text>
                {'\n\n'}In addition to the information contained in this privacy policy, this Application may provide the User with additional and contextual information concerning particular services or the collection and processing of Personal Data upon request.

                <Text style={{ fontSize: 18, fontWeight: '900' }}>
                    {'\n\n'}System logs and maintenance
                </Text>
                {'\n\n'}For operation and maintenance purposes, this Application and any third-party services may collect files that record interaction with this Application (System logs) use other Personal Data (such as the IP Address) for this purpose.

                <Text style={{ fontSize: 18, fontWeight: '900' }}>
                    {'\n\n'}Information not contained in this policy
                </Text>
                {'\n\n'}More details concerning the collection or processing of Personal Data may be requested from the Data Controller at any time. Please see the contact information at the beginning of this document.

                <Text style={{ fontSize: 18, fontWeight: '900' }}>
                    {'\n\n'}The rights of Users
                </Text>
                {'\n\n'}Users have the right, at any time, to know whether their Personal Data has been stored and can consult the Data Controller to learn about their contents and origin, to verify their accuracy or to ask for them to be supplemented, cancelled, updated or corrected, or for their transformation into anonymous format or to block any data held in violation of the law, as well as to oppose their treatment for any and all legitimate reasons. Requests should be sent to the Data Controller at the contact information set out above.
                {'\n\n'}This Application does not support “Do Not Track” requests.
                To determine whether any of the third-party services it uses honor the “Do Not Track” requests, please read their privacy policies.

                <Text style={{ fontSize: 18, fontWeight: '900' }}>
                    {'\n\n'}Changes to this privacy policy
                </Text>
                {'\n\n'}The Data Controller reserves the right to make changes to this privacy policy at any time by giving notice to its Users on this page. It is strongly recommended to check this page often, referring to the date of the last modification listed at the bottom. If a User objects to any of the changes to the Policy, the User must cease using this Application and can request that the Data Controller remove the Personal Data. Unless stated otherwise, the then-current privacy policy applies to all Personal Data the Data Controller has about Users.

                <Text style={{ fontSize: 18, fontWeight: '900' }}>
                    {'\n\n'}Information about this privacy policy
                </Text>
                {'\n\n'}The Data Controller is responsible for this privacy policy, prepared starting from the modules provided by iubenda and hosted on iubenda's servers.
            </Text>
        </ScrollView>
    )
    // endregion

    // region Render Contact Us Section
    const renderLinkItem = (link, icon, type = 'call') => (
        <TouchableOpacity
            onPress={() => {
                if (type === 'call') {
                    window.open(`tel:${link}`, '_blank');
                }
                else if (type === 'email') {
                    window.open(`mailto:${link}`, '_blank');
                }
                else if (type === 'link') {
                    window.open(`https://${link}`, '_blank');
                }
            }}
            style={{ flexDirection: 'row', alignItems: 'center', alignSelf: 'center', paddingVertical: 24 }}>
            <Image
                source={icon || require('../../images/icon_facebook.jpeg')}
                style={{ width: 28, height: 28, tintColor: GLOBAL.COLOR.BASIC.NEUTRAL_GREY }}
            />

            <Text style={{ fontSize: 18, color: GLOBAL.COLOR.BASIC.NEUTRAL_GREY, marginLeft: 16 }}>
                {link}
            </Text>
        </TouchableOpacity>
    );

    const renderDivider = () => <View style={{ height: 1, width: '25%', marginHorizontal: 24, backgroundColor: GLOBAL.COLOR.DIVIDER }}/>;

    const renderContactUsSection = () => (
        <ScrollView style={{ flex: 1, width: '100%' }} contentContainerStyle={{ alignItems: 'center' }}>
            {/* Content */}
            <Image
                source={require('../../images/icon_heart_bubble.png')}
                style={{ width: 64, height: 64, marginTop: 24 }}
                tintColor={GLOBAL.COLOR.MAIN}
            />

            <Text style={{ fontWeight: '900', fontSize: 26, marginTop: 24, marginBottom: 24, color: GLOBAL.COLOR.BASIC.BLACK_TWO }}>
                We'd love to hear from you
            </Text>

            {renderLinkItem('720-230-6750', require('../../images/iconLinePhone.png'), 'call')}
            {renderDivider()}
            {renderLinkItem('vendor.support@gotruckster.com', require('../../images/iconLineMail.png'), 'email')}
            {renderDivider()}
            {renderLinkItem('gotruckster.com', require('../../images/iconLineGlobe.png'), 'link')}
            {renderDivider()}
            {renderLinkItem('facebook.com/GoTruckster', require('../../images/iconSocialFacebook.png'), 'link')}
            {renderDivider()}
            {renderLinkItem('twitter.com/GoTruckster', require('../../images/iconSocialTwitter.png'), 'link')}
            {renderDivider()}
            {renderLinkItem('instagram.com/GoTruckster', require('../../images/iconSocialInstagram.png'), 'link')}
            {renderDivider()}
        </ScrollView>
    )
    // endregion

    // region Help and Support List
    const itemList = [
        {
            id: 1,
            title: 'About Us',
            icon: 'info',
            renderComp: () => renderAboutUsSection()
        },
        {
            id: 2,
            title: 'Frequently Asked Questions',
            icon: 'book-open',
            renderComp: () => renderFAQSection()
        },
        {
            id: 3,
            title: 'Privacy Policy',
            icon: 'shield',
            renderComp: () => renderPrivacyPolicySection()
        },
        {
            id: 4,
            title: 'Contact Us',
            icon: 'mail',
            renderComp: () => renderContactUsSection()
        }
    ];
    // endregion

    // region Render Item
    const renderItem = (itemData, index) => {
        const isChosen = selectedItemID === itemData.id;
        return(
            <Animatable.View
                key={`categoryItem_${itemData.id}`}
                animation={'fadeInUp'} duration={600} delay={index * DELAY_VALUE}
                style={{ width: '100%', borderBottomWidth: 1, borderColor: GLOBAL.COLOR.DIVIDER }}>
                <TouchableOpacity
                    onPress={() => {
                        if (!isChosen) {
                            setSelectedItemID(itemData.id);
                            mainView.current?.fadeInLeft(600);
                        }
                    }}
                    style={{
                        width: '100%', alignItems: 'center', flexDirection: 'row',
                        paddingHorizontal: 24, paddingVertical: 20,
                        backgroundColor: isChosen ? GLOBAL.COLOR.MAIN_SELECTED : 'white'
                    }}>
                    {/* Icon */}
                    <Feather name={itemData.icon || 'help-circle'} size={32} color={GLOBAL.COLOR.BASIC.BLACK_TWO} />

                    {/* Name */}
                    <Text style={{ color: 'black', fontSize: 18, lineHeight: 26, fontWeight: '500', textAlign: 'left', marginLeft: 16 }} numberOfLines={2}>
                        {toTitleCase(itemData.title)}
                    </Text>
                </TouchableOpacity>
            </Animatable.View>
        );
    }
    // endregion

    // region MAIN RENDER
    return(
        <View style={{ width: '100%', flex: 1 }}>
            {/* Nav Bar */}
            <View style={{
                flexDirection: 'row', width: '100%', alignItems: 'center',
                backgroundColor: 'white', borderBottomWidth: 1, borderBottomColor: GLOBAL.COLOR.DIVIDER,
                paddingVertical: 24, paddingHorizontal: 24
            }}>
                <Text style={{ fontSize: 28, fontWeight: '900' }}>
                    Help & Support
                </Text>
            </View>

            {/* Content */}
            <View style={{ flex: 1, width: '100%', flexDirection: 'row' }}>
                {/* Category */}
                <View style={{ width: '40%', minWidth: 350, maxWidth: 500, height: '100%', borderRightWidth: 1, borderColor: GLOBAL.COLOR.DIVIDER, zIndex: 100 }}>
                    <ScrollView
                        style={{ flex: 1, width: '100%', backgroundColor: 'white' }}
                        showsVerticalScrollIndicator={false}>
                        {itemList.map((item, index) => renderItem(item, index))}
                    </ScrollView>
                </View>

                {/* Items */}
                <Animatable.View
                    ref={mainView}
                    style={{ flex: 1, backgroundColor: 'white' }}>
                    {
                        selectedItemID ?
                            itemList[selectedItemID - 1]?.renderComp()
                            :
                            <View style={{ flex: 1, width: '100%', alignItems: 'center', justifyContent: 'center', padding: 64 }}>
                                <Text style={{ color: GLOBAL.COLOR.TEXT_LIGHT_GRAY, textAlign: 'center' }}>
                                    Select a Resource Category
                                </Text>
                            </View>
                    }
                </Animatable.View>
            </View>
        </View>
    );
    // endregion
}
